// Router.jsx
import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import Loading from "./Components/loading.js";

const Home = lazy(() => import("./Pages/Home/Home"));
const Error404 = lazy(() => import("./Pages/Error404/Error404"));
const Politica = lazy(() => import("./Pages/Politica/Politica.jsx"));
const Biografia = lazy(() => import("./Pages/Biografia/Biografia"));
const Autor = lazy(() => import("./Pages/Autor/Autor"));
const Cursos = lazy(() => import("./Pages/Cursos/Cursos"));
const Conteudo = lazy(() => import("./Pages/Conteudo/Conteudo"));
const Iniciação = lazy(() => import("./Pages/Iniciação/Iniciação"));
const IniciaçãoMeta = lazy(() => import("./Pages/IniciaçãoMeta/Iniciação.jsx"));
const Eventos = lazy(() => import("./Pages/Eventos/Eventos"));
const Contato = lazy(() => import("./Components/Pages/Contato/Contato"));
const Blog = lazy(() => import("./Components/Pages/Blog/Visao.jsx"));
const BlogPost = lazy(() => import("./Components/Pages/Blog/BlogPost.jsx"));
const LancamentoLivro = lazy(() => import("./Pages/LancamentoLivro/LancamentoLivro.jsx"));
const MentoriaBuzios = lazy(() => import("./Pages/MentoriaBuzios/MentoriaBuzios.jsx"));

export function Router() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/*" element={<Error404 />} />
        <Route path="/politica-de-privacidade" element={<Politica />} />
        <Route path="/biografia" element={<Biografia />} />
        <Route path="/autor" element={<Autor />} />
        <Route path="/cursos" element={<Cursos />} />
        <Route path="/conteudo" element={<Conteudo />} />
        <Route path="/blog/" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/eventos" element={<Eventos />} />
        <Route path="/lancamento-erindilogun" element={<LancamentoLivro />} />
        <Route path="/mentoriadapraticadejogodebuziosavancado" element={<MentoriaBuzios />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/iniciação-ifá" element={<Iniciação />} />
        <Route path="/iniciacao-ifa" element={<Iniciação />} />
        <Route path="/iniciação-ifá-meta" element={<IniciaçãoMeta />} />
        <Route path="/iniciacao-ifa-meta" element={<IniciaçãoMeta />} />
      </Routes>
    </Suspense>
  );
}
